var showErrorModal = function () {
    if ($('#frmLastOrder').length) {
        'use strict';
        var $form = $('#frmLastOrder');


        var action = $form[0].action;
        showErrorModalResults(action, $form);


    }
}
function showErrorModalResults(postUrl, form) {
    $.ajax({
        url: postUrl,
        type: 'POST',
        data: form.serialize(),
        success: function (data) {
            $('#frmLastOrder').html(data);
        },
        error: function (jqXhr) {
            // To handle time out error or any other errors

        }
    });
}


function onClickFavoriteReOrder(event) {
    event.stopPropagation()
    analytics.closeModal()
    if (disableFavReorder !== "false") {
    } else {
        var reOrderCartId = event.currentTarget.children[2].getAttribute('data-cartid');

        /* For Analytics */
        var prdName = event.currentTarget.children[2].children[0].getAttribute('data-name');
        var productVariable = "favorites" + ";" + event.currentTarget.children[2].children[0].textContent.toLowerCase();
        var total = $('#num-favorites').val();
        var currPosition = parseInt(event.currentTarget.getAttribute('data-slick-index')) + 1;
        var position = total + "|" + currPosition;
        orderViewModel.currentOrder.favPosition = position;
        orderViewModel.currentOrder.favName = prdName;
        orderViewModel.save();
        analytics.favoriteCarouselClick(prdName);

        if (orderViewModel.store.StoreId) {
            onClickReOrderFavorite(reOrderCartId);
        }
        else {
            removeDancingBubbleIfAny();
            //remove error modal close if storeId is null, No call will happen if store ID is null.
        }
    }
}

function onClickBestSellerReOrder(event) {
    event.stopPropagation();
    /* For Analytics */
    var prdName = event.currentTarget.children[1].children[0].getAttribute('data-name');
    var total = $('#num-bestsellers').val();
    var slickElement = event.currentTarget.closest('[data-slick-index]');
    var currPosition = slickElement ? parseInt(slickElement.getAttribute('data-slick-index')) + 1 : 0;
    var position = total + "|" + currPosition;
    orderViewModel.currentOrder.favPosition = position;
    orderViewModel.currentOrder.favName = prdName;
    orderViewModel.save();
    analytics.favCarouselLinkCall(position, prdName, $('#bestSellerAnalytics').text());
}


var onClickReOrderFavorite = function (reOrderCartId) {
    showFavoritesErrorModal(reOrderCartId);
}
var showFavoritesErrorModal = function (reOrderCartId) {
    var cartId = orderViewModel.currentOrder.cartId;
    var storeId = orderViewModel.store.id;
    var itemId = reOrderCartId;
    analytics.ReOrderCart(cartId);
    validateFavorite(cartId, storeId, itemId)
}

function showLastOrderReOrderErrorModal(productsArray = []) {
    orderViewModel.tempRecentProductDetails = null;
    orderViewModel.tempRecentProductDetails = productsArray;
    $('#lastOrderReOrderModal').css('display', "block");
}



function showReOrderErrorModal() {
    $('#reOrderModal').css('display', "block");
    analytics.modalCheckOut("favorite error modal");
    analytics.favoritesWarning($('.prd-items').text());
}

function closeReOrderErrorModal(event, id) {
    analytics.closeModal();
    if (event !== undefined)
        event.preventDefault();
    $(id).css('display', "none");

}

function handleClickAnalytics(ctaText) {
    analytics.pageLink(ctaText);
    analytics.storeClosePopupModal();
}

function storeClosePopupCtaClick(ctaText) {
    handleClickAnalytics(ctaText)
    $('#storeClosedOrderAheadModal').remove();
    var lastOrderType = (window.orderViewModel.orderType === null ||
        window.orderViewModel.orderType === undefined ||
        window.orderViewModel.orderType === "")
        ? window.orderViewModel.lastOrderFulfillmentType :
        window.orderViewModel.orderType;
    if (lastOrderType === 'delivery') {
        return;
    }
    window.location.href = window.subwayScript.navigation.getMenuUrl(orderViewModel && orderViewModel.store && (orderViewModel.store.StoreId || orderViewModel.store.id));
}
function storeClosePopupCtaClickDelivery() {
    $("#storeClosedOrderAheadModalDelivery").hide();
}
function showStoreCloseOAPopupDashboard(createStoreErrorDataRes) {
    if(createStoreErrorDataRes === undefined || createStoreErrorDataRes === null) {
        return;
    }
    analytics.storeCloseModalAnalytics('location closed modal', true, createStoreErrorDataRes)
    $('#storeClosedOrderAheadModal').remove();
    let ctaList = "";
    createStoreErrorDataRes && createStoreErrorDataRes.buttonList
        && createStoreErrorDataRes.buttonList.length > 0 
        && createStoreErrorDataRes.buttonList.forEach((cta, index) => {
            if (cta.url == undefined || cta.url == null || cta.url == "") {
                ctaList += `<button class="popup__button" data-testauto-id="store-close-cta-${index}" onClick="storeClosePopupCtaClick('${cta.buttonText}')">
    <span class="button__content">${cta.buttonText}</span> </button>`;
            } else {
                ctaList += `<a href="${cta.url}" class="${index !== 0 ? "popup__link" : "popup__button"}" data-testauto-id="store-close-cta-${index}" onClick="handleClickAnalytics('${cta.buttonText}')">
            ${cta.buttonText}
    </a>`;
            }
        });
    const baseUrl = window.location.origin;
    const modalHTML = `<div id="storeClosedOrderAheadModal" class="focus-modal-popup" aria-hidden="false">
     <div class="modalPopup order-ahead-popup">
            <div class="modalPopup__wrapper">
                <dialog class="modalPopup__container slideDown modalData" aria-labelledby="title__labelledby" aria-modal="true" role="alertdialog" data-modal-background-click="disabled" open>
                    <div class="modal_header">
                        <button class="modalPopup__close"
                        data-testid="modal-popup-closeBtn"
                        data-testauto-id="modal-popup-closeBtn"
                        aria-label="Close" style="height: revert-layer;"
                        onClick="storeClosePopupCtaClick('close')">
                        <img src="${baseUrl}/Assets/RemoteOrder/img/close.png" alt="Close" />
                        </button>
                        <div class="modalPopup__header">
                            <h2 class="modalPopup_title" id="title__labelledby" data-testid="common-modal-title" data-testauto-id="common-modal-title">
                            ${createStoreErrorDataRes.title}
                            </h2>
                        </div>
                    </div>
                    <div class="modalPopup__body" data-testauto-id="common-modal-description">
                        ${(createStoreErrorDataRes.message === null || 
                            createStoreErrorDataRes.message === undefined) ? '' : createStoreErrorDataRes.message}
                    </div>
                    <div class="modalPopup__button">
                        ${ctaList}
                    </div>
                </dialog>
            </div>
        </div >
    </div >`;
    $('body').append(modalHTML);
}
var validateFavorite = function (cartId, storeId, itemId) {
    var submitRoute = $('#frmReorderItem').attr('action');
    var model = {
        StoreId: subwayScript.checkSatelliteNumber(storeId),
        CurrentOrderCartId: cartId,
        ReorderedItemCartItemId: itemId,
        "SiteName": $('#hdnSiteName') && $('#hdnSiteName').val() || ""
    };
    //show spinner
    $.ajax({
        url: submitRoute,
        type: 'POST',
        data: model,
        success: function (response) {
            var createStoreErrorDataRes = response && response.storeError && response.storeError.createStoreErrorData;
            if (createStoreErrorDataRes == undefined || createStoreErrorDataRes == null) {
                if (response !== null && response.Favorites !== undefined) {
                    var isAllAvaliable = true;
                    $('.products-avaliability').remove();
                    $('#order-btn').unbind('click keydown');

                    for (var i = 0; i < response.Favorites.length; i++) {
                        var price = response.Favorites[i].Price;
                        var isAvailable = response.Favorites[i].IsAvailable;
                        var productName = response.Favorites[i].ProductName;
                        var favoriteName = response.Favorites[i].FavoriteName;
                        var itemDescription = response.Favorites[i].ItemDescription;
                        var ingredientsAvailable = response.Favorites[i].AreAllIngredientsAvailable;
                        var inStockItems = response.Favorites[i].InStockItems;
                        var outofStockItems = response.Favorites[i].OutofStockItems;
                        var productNotAvailableMessage = $('#product-outofstock').val();
                        var unavailableIngredients = $('#unavailable-item').val();
                        var isCombo = response.Favorites[i].Item && response.Favorites[i].Item.combo && Object.keys(response.Favorites[i].Item.combo).length !== 0 ? true : false;
                        // if item is not available, add-to-bag CTA prompts user to Change Location
                        if (isAvailable == false) {
                            removeDancingBubbleIfAny();
                            // open the itemUnavailable modal
                            addReOrderProductsUI()
                            $(".prd-name").text(productName);
                            $(".prd-items").text(productNotAvailableMessage);
                            showReOrderErrorModal();
                            $('#reOrderModal #reOrderModal-btn').attr('onClick', 'startneworder("#reOrderModal", true, event)');
                            $('#order-btn').css('display', 'none');
                            isAllAvaliable = false;
                        }
                        // if any ingredients are not available, add-to-bag CTA prompts user to either add to bag AS IS or change Location
                        else if (ingredientsAvailable == false) {
                            removeDancingBubbleIfAny();
                            addReOrderProductsUI()
                            $(".prd-name").text(productName);
                            $(".prd-items").text(unavailableIngredients + " " + outofStockItems)
                            showReOrderErrorModal();
                            $('#order-btn').css('display', 'block');
                            isAllAvaliable = false;
                        }
                    }
                    if (isAllAvaliable) {
                        addToBag(storeId, cartId, itemId, productName, price, isCombo);
                    }

                    $('#order-btn').on('click keydown', function (e) {
                        if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
                            analytics.pageLink(e.target.innerText,"favorite error modal");
                            setTimeout(() => {
                                applyDancingBubble(e, 'white', true);
                                e.stopImmediatePropagation();
                                addToBag(storeId, cartId, itemId, '', '', isCombo)
                            });
                        }
                    });
                }
            }
            else {
                removeDancingBubbleIfAny();
                showStoreCloseOAPopupDashboard(createStoreErrorDataRes);
                return;
            }
        },
        error: function (jqXhr) {
            removeDancingBubbleIfAny();
            closeReOrderErrorModal(undefined, "#reOrderModal");

            if (jqXhr.responseJSON && jqXhr.responseJSON.Error && jqXhr.responseJSON.Error.Title == "Item not in stock") {
                addReOrderComboProductsUI();
                $(".prd-name").text('One of the Combo items is out of stock');
                showReOrderErrorModal();
                $('#order-btn').on('click', function (e) {
                    e.stopImmediatePropagation();
                    analytics.pageLink(e.target.innerText);
                    addToBag(storeId, cartId, itemId, '', '');
                });
                $('#order-btn').css('display', 'block');
            }
            else {
                subwayScript.showAjaxError(jqXhr);
            }
        }
    });
};

function removeDancingBubbleIfAny() {
    removeDancingBubble(null);
    const bubbleTarget = document.querySelector('.dancing-bubble-target');
    if (bubbleTarget) {
        bubbleTarget.remove();
        $('.fav-card-resp-height').removeClass('half-opacity');
    }
}


function addReOrderComboProductsUI() {
    $('#reordermodal-body').append($('<div class="products-avaliability"></div >').append('<div class= "prd-name"></div>'))

}



function addReOrderProductsUI() {

    $('#reordermodal-body').append($('<div class="products-avaliability"></div >').append('<div class= "prd-name"> Over Roasted Chicken</div><div class="prd-items">Product Unavaliable</div>'))


}
function startneworder(modalId, isfav, event) {
    if (isCurrentPage('locator') || isCurrentPage('deliveryLocator')) {
        modalClose(true);
        return;
    }
    if(event){
        applyDancingBubble(event, 'gray', true)
    }
    if (modalId != "#modal-store-closed") {
        if (isCurrentPage("home")) {
            analytics.switchLocation("dashboard_click_action");
        } else if (isCurrentPage("menu")) {
            analytics.switchLocation("menu_click_action");
        } else if (isCurrentPage("my-favorites")) {
            analytics.switchLocation("account_click_action");
        } else if (isCurrentPage("recent-orders")) {
            analytics.switchLocation("recent_order_click_action");
        }
    }

    if(isfav) {
        orderViewModel.isFavoriteOrder = true;
        orderViewModel.save();
    }
    if(isfav) {
        orderViewModel.isFavoriteOrder = true;
        orderViewModel.save();
    }
    setTimeout(() => {
        window.location.href = subwayScript.navigation.getLocatorUrl();
    }, 1000);
}
$(document).on('click', '#viewRecentOrderClick', function () {
    var buttonText = $(this).text().trim();
    analytics.cardListClick(buttonText);
});
function startnewOrderLast(event, buttonText) {
    if (event) {
        applyDancingBubble(event, 'white', true)
        event.preventDefault();
        analytics.startNewOrderClick(buttonText);
    }
    if (isCurrentPage('locator') || isCurrentPage('deliveryLocator')) {
        modalClose(true);
        return;
    }
    if (orderViewModel.store.id) {
        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id)
    } else {

        if (orderViewModel.orderType == 'delivery' || orderViewModel.defaultStoreDetails.orderType == 'delivery') {
            window.location.href = subwayScript.navigation.getDeliveryLocatorUrl()
        } else {
            if (orderViewModel.showModalId != '') {
                modalShowId(orderViewModel.showModalId);
            } else {
                window.location.href = subwayScript.navigation.getLocatorUrl();
            }
        }

    }
}
